import { database } from './firebase';
import { User, UserRole, initialFlightData } from '../types';
import { ref, set, remove } from 'firebase/database';

const defaultUsers: User[] = [
  { id: 'super_admin_permanent', username: 'JBP', password: 'J0hnismastr', role: UserRole.ADMIN, authCode: 'SUPER_ADMIN_SEED' },
  { id: 'admin_demo', username: 'admin', password: 'admin', role: UserRole.ADMIN, authCode: 'ADMIN_SEED' },
  { id: 'supervisor_demo', username: 's', password: 's', role: UserRole.SUPERVISOR, authCode: 'SUPER' },
  { id: 'agent_demo', username: 'a', password: 'a', role: UserRole.AGENT, authCode: 'AGENT' },
  { id: 'viewer_demo', username: 'v', password: 'v', role: UserRole.VIEWER, authCode: 'VIEW' },
];

const defaultAuthCodes = {
    'SUPER': UserRole.SUPERVISOR,
    'AGENT': UserRole.AGENT,
    'VIEW': UserRole.VIEWER,
};

const defaultFlightNumbers = ['JT001', 'JT002', 'JT003'];

export const resetDatabaseToDefaults = async (): Promise<void> => {
    const usersObject = defaultUsers.reduce((acc, user) => {
        acc[user.id] = user;
        return acc;
    }, {} as { [key: string]: User });

    const defaultData = {
        users: usersObject,
        config: {
            registrationOpen: true,
            authCodes: defaultAuthCodes,
            flightNumbers: defaultFlightNumbers,
            securityScanPercentage: 10,
            assets: null,
        },
        activeFlights: null,
        flightRecords: null,
        loginHistory: null,
        newSessionHistory: null,
    };

    await set(ref(database), defaultData);
};

export const clearReportsHistory = async (): Promise<void> => {
    await remove(ref(database, 'flightRecords'));
};

export const clearLoginHistory = async (): Promise<void> => {
    await remove(ref(database, 'loginHistory'));
};

export const clearNewSessionHistory = async (): Promise<void> => {
    await remove(ref(database, 'newSessionHistory'));
};
